import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class PollState {
  constructor(poll, post) {
    _defineProperty(this, "poll", void 0);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "pendingSubmit", false);
    _defineProperty(this, "pendingOptions", null);
    _defineProperty(this, "loadingOptions", false);
    _defineProperty(this, "useSubmitUI", void 0);
    _defineProperty(this, "showCheckMarks", void 0);
    _defineProperty(this, "canSeeVoteCount", void 0);
    _defineProperty(this, "showVoters", () => {
      // Load all the votes only when opening the votes list
      app.modal.show(() => import(/* webpackChunkName: 'forum/components/ListVotersModal', webpackMode: 'lazy-once' */ '../components/ListVotersModal'), {
        poll: this.poll,
        post: this.post
      });
    });
    this.poll = poll;
    this.post = post;
    this.useSubmitUI = !(poll != null && poll.canChangeVote()) && (poll == null ? void 0 : poll.allowMultipleVotes());
    this.showCheckMarks = !app.session.user || !poll.hasEnded() && poll.canVote() && (!this.hasVoted() || poll.canChangeVote());
    this.canSeeVoteCount = typeof poll.voteCount() === 'number';
    this.init();
  }

  /**
   * used as en extendable entry point for init customizations
   */
  init() {}
  isShowResult() {
    return this.poll.hasEnded() || this.canSeeVoteCount && !!app.session.user && this.hasVoted();
  }
  hasVoted() {
    return this.poll.myVotes().length > 0;
  }
  overallVoteCount() {
    return this.poll.voteCount();
  }
  hasVotedFor(option) {
    return this.pendingOptions ? this.pendingOptions.has(option.id()) : this.poll.myVotes().some(vote => vote.option() === option);
  }
  getMaxVotes() {
    const poll = this.poll;
    let maxVotes = poll.allowMultipleVotes() ? poll.maxVotes() : 1;
    if (maxVotes === 0) maxVotes = poll.options().length;
    return maxVotes;
  }
  showButton() {
    return this.useSubmitUI && this.pendingSubmit;
  }
  changeVote(option, evt) {
    const target = evt.target;
    if (!app.session.user) {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
      target.checked = false;
      return;
    }
    const optionIds = this.pendingOptions || new Set(this.poll.myVotes().map(v => v.option().id()));
    const isUnvoting = optionIds.delete(option.id());
    const allowsMultiple = this.poll.allowMultipleVotes();
    if (!allowsMultiple) {
      optionIds.clear();
    }
    if (!isUnvoting) {
      optionIds.add(option.id());
    }
    this.pendingOptions = optionIds.size ? optionIds : null;
    this.pendingSubmit = !!this.pendingOptions;
    if (this.useSubmitUI) {
      m.redraw();
      return;
    }
    this.submit(optionIds, () => {
      this.pendingOptions = null;
      this.pendingSubmit = false;
    }, () => target.checked = isUnvoting);
  }
  hasSelectedOptions() {
    return this.pendingSubmit;
  }
  onsubmit() {
    return this.submit(this.pendingOptions, () => {
      this.pendingOptions = null;
      this.pendingSubmit = false;
    });
  }
  submit(optionIds, cb, onerror) {
    if (onerror === void 0) {
      onerror = null;
    }
    this.loadingOptions = true;
    m.redraw();
    return app.request({
      method: 'PATCH',
      url: "".concat(app.forum.attribute('apiUrl'), "/polls/").concat(this.poll.id(), "/votes"),
      body: {
        data: {
          optionIds: Array.from(optionIds)
        }
      }
    }).then(res => {
      app.store.pushPayload(res);
      cb == null || cb();
    }).catch(err => {
      var _onerror;
      (_onerror = onerror) == null || _onerror(err);
    }).finally(() => {
      this.loadingOptions = false;
      this.canSeeVoteCount = typeof this.poll.voteCount() === 'number';
      m.redraw();
    });
  }
}
flarum.reg.add('fof-polls', 'forum/states/PollState', PollState);flarum.reg.addChunkModule('540', '2644', 'fof-polls', 'forum/components/ListVotersModal');